import React from "react";
import CardContainer from "../../cardContainer";
import FleetOverviewCardContent from "./fleetOverViewCardContent";
import { EmployeeData, VehicleData } from "../../../../models/monitorView/monitorViewTypes";

import { employeeGroupListItemDto } from "../../../../models/employeeGroup/employeeGroup";
import { getWorkTimeTypeColorCode } from "../../../../models/workShitTimeSlot/workTimeType";

interface FleetOverviewCardProps {
    employee?: EmployeeData;
    employeeGroups: employeeGroupListItemDto[];
    vehicle?: VehicleData;
    isSelected: boolean;
    onClickCard: () => void;
    onSelectEmployee: () => void;
}

const FleetOverviewCard: React.FC<FleetOverviewCardProps> = ({ employee, employeeGroups, isSelected, vehicle, onClickCard, onSelectEmployee }) => {
    return (
        <CardContainer isSelected={isSelected}
            cardStyles={{
                borderRadius: "10px",
                marginBottom: 2,
                ...(employee?.workTimeTypeType
                    ? { borderLeft: "3px solid",
                        borderColor: `${getWorkTimeTypeColorCode(employee.workTimeTypeType)}` }
                    : {}),
            }}
            cardContentStyles={{
                padding: 0.5
            }}
            onClick={onClickCard}
        >
            <FleetOverviewCardContent
                vehicle={vehicle}
                employee={employee}
                employeeGroups={employeeGroups}
                onSelectEmployee={onSelectEmployee}
            />
        </CardContainer>
    );
};

export default FleetOverviewCard;